// This component is deprecated — use GlobalFrictionButton instead.
// Kept as a no-op export to avoid breaking existing imports.
export function ReportFrictionButton(_props: { moduleName?: string; jobId?: string }) {
  return null;
}
